import { TeachingLearningSequence } from 'approot/activity-builder/components/teaching-notes/__generated__/TeachingLearningSequence';
import { isRichtextEmpty } from 'approot/shared/richtext/richtext.utils';
import { LEARNING_SEQUENCE_CATEGORY_EXPLANATION } from 'global/constants';

export function getActivityExplanationSequenceItem(
  sequences: TeachingLearningSequence[] | null,
  componentId: string
) {
  return sequences?.find(
    s =>
      s.category === LEARNING_SEQUENCE_CATEGORY_EXPLANATION &&
      s.component?.id === componentId &&
      !isRichtextEmpty(s.data)
  );
}
